export default function OpportunityHighlightsList({ highlights = [], maxItems = null, className = "" }) {
    const items = maxItems != null ? highlights.slice(0, maxItems) : highlights;
    if (items.length === 0) return null;

    return (
        <ul className={`mb-0 space-y-1.5 ${className}`.trim()}>
            {items.map((highlight, index) => (
                <li
                    key={`${highlight}-${index}`}
                    className={`flex gap-2 text-slate-600 ${
                        maxItems != null ? "text-xs leading-snug" : "text-sm leading-relaxed"
                    }`}
                >
                    <i
                        className="bi bi-stars mt-0.5 shrink-0 text-[11px] text-amber-500"
                        aria-hidden
                    />
                    <span className={maxItems != null ? "line-clamp-1 min-w-0" : "break-words"}>
                        {highlight}
                    </span>
                </li>
            ))}
        </ul>
    );
}
